import { SvgIconProps } from "@mui/material";

// 3 columns x 2 rows -- matches the "rows x columns" convention used for
// this app's grouped-grid labels (e.g. "2 x 3").
export const TwoByThreeGridIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="6" height="9.5" rx="1.5" />
    <rect x="9" y="2" width="6" height="9.5" rx="1.5" />
    <rect x="16" y="2" width="6" height="9.5" rx="1.5" />
    <rect x="2" y="12.5" width="6" height="9.5" rx="1.5" />
    <rect x="9" y="12.5" width="6" height="9.5" rx="1.5" />
    <rect x="16" y="12.5" width="6" height="9.5" rx="1.5" />
  </svg>
);
